import { Card, CardContent, CardHeader, styled } from "@mui/material";
import clsx from "clsx";
import { IListItem } from "../../interface/list-item";
import { ITreeItem } from "../../interface/tree-item";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import { StrictModeDroppable } from "./droppable";
import { BoxHeaderName } from "./enum/box-header";
import ListOptions from "./list-options";
import TreeOptions from "./tree-options";

interface IProps extends IWithClassName {
    title: string;
    data: Array<ITreeItem>;
    isTreeView: boolean;
    onHighlight: (isChecked: boolean, item: IListItem) => void;
    droppableId: BoxHeaderName;
    isSingleColumn: boolean;
    leftDraggerInTransition?: string | null;
    rightDraggerInTransition?: string | null;
    error?: string;
    disabled?: boolean;
}

const OptionBox = ({
    className,
    title,
    data,
    isTreeView,
    onHighlight,
    droppableId,
    isSingleColumn,
    leftDraggerInTransition,
    rightDraggerInTransition,
    error,
    disabled,
}: IProps) => (
    <Card className={className}>
        <CardHeader
            title={title}
            className={clsx("box-header", { "disabled-header": disabled })}
            subheader={error}
        />
        <StrictModeDroppable droppableId={droppableId}>
            {(provided) => (
                <CardContent
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                >
                    {isTreeView ? (
                        <TreeOptions
                            data={data}
                            onHighlight={onHighlight}
                            draggerInTransition={leftDraggerInTransition}
                            rightDraggerInTransition={rightDraggerInTransition}
                        />
                    ) : (
                        <ListOptions
                            data={data}
                            onHighlight={onHighlight}
                            isSingleColumn={isSingleColumn}
                            disabled={disabled}
                        />
                    )}
                    {provided.placeholder}
                </CardContent>
            )}
        </StrictModeDroppable>
    </Card>
);

export default styled(OptionBox)(({ theme }: IWithThemeProps) => ({
    flex: "auto",
    width: "45%",
    minHeight: 400,
    ".box-header": {
        borderBottom: `1px solid ${
            theme?.palette.detailsPane.borderBottom ?? ""
        }`,
    },
    ".disabled-header": {
        opacity: 0.3,
    },
    ".parent-item": {
        borderRadius: 0,
        zIndex: 20,
        ".MuiCardHeader-root": {
            padding: 0,

            ".MuiCardHeader-title": {
                fontSize: 18,
                cursor: "pointer",
            },
            ".MuiCardHeader-avatar": {
                marginRight: theme?.spacing(0.5),
            },
        },
    },
    ".hide": {
        display: "none",
    },
    ".MuiCardContent-root": {
        height: "100%",
        ul: {
            listStyle: "none",
        },
    },
    ".MuiCardHeader-subheader": {
        color: theme?.palette.error.main,
    },
}));
